/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guide-graphics/dialog': {
    width: 16,
    height: 16,
    viewBox: '0 0 352 80',
    data: '<g data-name="Layer 2"><path pid="0" d="M40.5 0h271C333.87 0 352 17.91 352 40s-18.13 40-40.5 40h-271C18.13 80 0 62.09 0 40S18.13 0 40.5 0z" _fill="#fff" data-name="Layer 1"/></g>'
  }
})
